import React, { useState } from 'react';
import LeftMenu from './LeftMenu';
import './Dashboard.css';
import UserManagement from '../userManagement/UserManagement';
import ManageRole from '../manageRole/ManageRole';
import Requester from '../requester/Requester';
import UploadExcelChainWide from '../digitalPriceTag/UploadExcelChainWide';
import UploadExcelRoadShow from '../digitalPriceTag/UploadExcelRoadShow';
import UploadExcelSelectedShop from '../digitalPriceTag/UploadExcelSelectedShop';
import ExcelUploadLog from '../digitalPriceTag/ExcelUploadLog';

//utils
import {
  LEFT_MENU_ADMINISTRATION,
  LEFT_MENU_ROLE_AND_PERMISSION,
  LEFT_MENU_REQUESTER,
  LEFT_MENU_USER_MANAGEMENT,
  LEFT_MENU_DIGITAL_PRICE_TAG,
  LEFT_MENU_SUB_UPLOAD_EXCEL_CHAIN_WIDE,
  LEFT_MENU_SUB_UPLOAD_EXCEL_ROADSHOW,
  LEFT_MENU_EXCEL_UPLOAD_LOG,
  LEFT_MENU_SUB_UPLOAD_EXCEL_SELECTED_SHOP
} from '../../utils/constant';

function Dashboard() {
  const [selectedMenu, setSelectedMenu] = useState(LEFT_MENU_SUB_UPLOAD_EXCEL_CHAIN_WIDE);

  const handleMenuSelect = (menuTitle) => {
    setSelectedMenu(menuTitle);
  };

  const renderContent = () => {
    switch (selectedMenu) {
      case LEFT_MENU_USER_MANAGEMENT:
        return <UserManagement />;
      case LEFT_MENU_ROLE_AND_PERMISSION:
        return <ManageRole />;
      case LEFT_MENU_REQUESTER:
        return <Requester />;
      case LEFT_MENU_SUB_UPLOAD_EXCEL_CHAIN_WIDE:
        return <UploadExcelChainWide />;
      case LEFT_MENU_SUB_UPLOAD_EXCEL_ROADSHOW:
        return <UploadExcelRoadShow />;
      case LEFT_MENU_SUB_UPLOAD_EXCEL_SELECTED_SHOP:
        return <UploadExcelSelectedShop />;
      case LEFT_MENU_EXCEL_UPLOAD_LOG:
        return <ExcelUploadLog />;
      default:
        return <UploadExcelChainWide />;
    }
  };

  const menuItems = [LEFT_MENU_ADMINISTRATION, LEFT_MENU_DIGITAL_PRICE_TAG];

  return (
    <div className="dashboard-container">
      <div className="sidebar">
        {menuItems.map((item) => (
          <LeftMenu key={item} title={item} onSelect={handleMenuSelect} activeMenuItem={selectedMenu} />
        ))}
      </div>
      <div className="content">
        {renderContent()}
      </div>
    </div>
  );
}

export default Dashboard;